import { PBIEmbeddedInput } from '../../types/pbi-embedded.type';
import { models } from 'powerbi-client';

export class InitializePBI {
  static readonly type = '[PBI] Initialize';
  constructor(public input: PBIEmbeddedInput, public initialPage?: string) {}
}
export class SetSelectedField {
  static readonly type = '[PBI] Set Selected Field';
  constructor(public field: string[]) {}
}

export class SetTitleFromSelectedField {
  static readonly type = '[PBI] Set Title From Selected Field';
  constructor(public field: string[]) {}
}

export class ChangePage {
  static readonly type = '[PBI] Change Page';
  constructor(public page: string) {}
}

export class SetPages {
  static readonly type = '[PBI] Set Pages';
  constructor(public pages: models.IPage[]) {}
}
